import type {BioIconProps} from '../../icons/common-types'

export default function BestHomeFixPicksLogo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M24 25.1466H22.9867C21.92 25.1466 20.9067 25.5599 20.16 26.3066L17.88 28.5599C16.84 29.5866 15.1466 29.5866 14.1066 28.5599L11.8267 26.3066C11.08 25.5599 10.0533 25.1466 9 25.1466H8C5.78667 25.1466 4 23.3733 4 21.1866V6.63993C4 4.45327 5.78667 2.67993 8 2.67993H24C26.2133 2.67993 28 4.45327 28 6.63993V21.1866C28 23.3599 26.2133 25.1466 24 25.1466Z"
          fill="#EDEDED"
        />
        <path
          d="M16.3733 19.9466C16.1733 20.0132 15.84 20.0132 15.6267 19.9466C13.8933 19.3466 10 16.8799 10 12.6799C10 10.8266 11.4933 9.33325 13.3333 9.33325C14.4267 9.33325 15.3867 9.85325 16 10.6666C16.6133 9.85325 17.5733 9.33325 18.6667 9.33325C20.5067 9.33325 22 10.8266 22 12.6799C21.9867 16.8799 18.1067 19.3466 16.3733 19.9466Z"
          fill="#EDEDED"
        />
      </svg>
      <span>Best Home Fix Picks</span>
    </div>
  )
}
